import { useSelector } from 'react-redux'
import { Line } from 'recharts'
import { CalculateSize } from '../../../../../../../../common/CalculateSize'
import { ChartContainer } from '../../../../../../../../common/chart/chartContainer'
import { Legend } from '../../../../../../../../common/chart/legend'
import { Loading } from '../../../../../../../../common/loading'
import { Notification } from '../../../../../../../../common/notification'
import { formatVal } from '../../../../../../../../helpers/value'
import {
  selectIsLoading,
  selectIsShowTradeData,
  selectRawData,
} from '../../../store/slice'

export const Content = () => {
  const locale = useSelector((state) => state.i18n.locale)
  const data = useSelector(selectRawData)
  const isLoading = useSelector(selectIsLoading)
  const isShow = useSelector(selectIsShowTradeData)

  const isMainChart = data
    .filter((item) => item.isMain === true)
    .map((item) => ({
      name: item.vsicName,
      year: item.year,
      data1: item.importGrowthRate,
      data2: item.exportGrowthRate,
      data3: item.balanceOfTradeGrowthRate,
    }))
  const vsicIdChart = data
    .filter((item) => item.vsicId === 0)
    .map((item) => ({
      name: item.vsicName,
      year: item.year,
      data4: item.importGrowthRate,
      data5: item.exportGrowthRate,
      data6: item.balanceOfTradeGrowthRate,
    }))

  const getContentTooltip = () => {
    const result = [
      {
        dataKey: 'data1',
        label: 'industryOverview.macroeconomics.IMPORT',
        unit: '%',
        isI18n: true,
        formatValue: (val) => formatVal(val * 100, locale),
      },
      {
        dataKey: 'data2',
        label: 'industryOverview.macroeconomics.EXPORT',
        unit: '%',
        isI18n: true,
        formatValue: (val) => formatVal(val * 100, locale),
      },
      {
        dataKey: 'data3',
        label: 'industryOverview.macroeconomics.BALANCE_OF_TRADE',
        unit: '%',
        isI18n: true,
        formatValue: (val) => formatVal(val * 100, locale),
      },
    ]

    if (isShow) {
      return [
        ...result,
        {
          dataKey: 'data4',
          label: 'industryOverview.macroeconomics.IMPORT_ALL_INDUSTRIES',
          unit: '%',
          isI18n: true,
          formatValue: (val) => formatVal(val * 100, locale),
        },
        {
          dataKey: 'data5',
          label: 'industryOverview.macroeconomics.EXPORT_ALL_INDUSTRIES',
          unit: '%',
          isI18n: true,
          formatValue: (val) => formatVal(val * 100, locale),
        },
        {
          dataKey: 'data6',
          label:
            'industryOverview.macroeconomics.BALANCE_OF_TRADE_ALL_INDUSTRIES',
          unit: '%',
          isI18n: true,
          formatValue: (val) => formatVal(val * 100, locale),
        },
      ]
    }

    return result
  }

  if (isLoading) {
    return (
      <div className="h100 positionRelative">
        <Loading />
      </div>
    )
  }

  if (!isMainChart.length && !vsicIdChart.length) {
    return <Notification />
  }

  return (
    <div className="flexColumn h100">
      <div className="flex1 positionRelative">
        <CalculateSize height="100%">
          {(size) => {
            return (
              <ChartContainer
                data={vsicIdChart.map((_, index) => ({
                  ...isMainChart[index],
                  ...vsicIdChart[index],
                }))}
                width={'100%'}
                height={size.height}
                xAxis={[
                  {
                    dataKey: 'year',
                    padding: {
                      left: 30,
                      right: 30,
                      allowDuplicatedCategory: false,
                    },
                  },
                ]}
                yAxis={[
                  {
                    yAxisId: 'left',
                    dataKeys: isShow
                      ? ['data1', 'data2', 'data3', 'data4', 'data5', 'data6']
                      : ['data1', 'data2', 'data3'],
                    isLineChart: true,
                    unit: '%',
                    tickFormatter: (value) => formatVal(value * 100, locale),
                  },
                ]}
                tooltip={{
                  schema: {
                    content: getContentTooltip(),
                  },
                }}
              >
                <Line
                  yAxisId={'left'}
                  dataKey={'data1'}
                  stroke="#006AA6"
                  strokeWidth={2}
                  dot={false}
                />
                <Line
                  yAxisId={'left'}
                  dataKey={'data2'}
                  stroke="#FFCD60"
                  strokeWidth={2}
                  dot={false}
                />
                <Line
                  yAxisId={'left'}
                  dataKey={'data3'}
                  stroke="#00A8B5"
                  strokeWidth={2}
                  dot={false}
                />
                {isShow && (
                  <>
                    <Line
                      yAxisId={'left'}
                      dataKey={'data4'}
                      stroke="#FF596A"
                      strokeWidth={2}
                      dot={false}
                    />
                    <Line
                      yAxisId={'left'}
                      dataKey={'data5'}
                      stroke="#7F63B9"
                      strokeWidth={2}
                      dot={false}
                    />
                    <Line
                      yAxisId={'left'}
                      dataKey={'data6'}
                      stroke="#B3CC85"
                      strokeWidth={2}
                      dot={false}
                    />
                  </>
                )}
              </ChartContainer>
            )
          }}
        </CalculateSize>
      </div>

      <div className="flexColumn gap1">
        <Legend
          className="dFlex gap2"
          items={[
            {
              key: 1,
              color: '#006AA6',
              title: 'industryOverview.macroeconomics.IMPORT',
            },
            {
              key: 2,
              color: '#FFCD60',
              title: 'industryOverview.macroeconomics.EXPORT',
            },
            {
              key: 3,
              color: '#00A8B5',
              title: 'industryOverview.macroeconomics.BALANCE_OF_TRADE',
            },
          ]}
        />
        {isShow && (
          <Legend
            className="dFlex gap2"
            items={[
              {
                key: 4,
                color: '#FF596A',
                title: 'industryOverview.macroeconomics.IMPORT_ALL_INDUSTRIES',
              },
              {
                key: 5,
                color: '#7F63B9',
                title: 'industryOverview.macroeconomics.EXPORT_ALL_INDUSTRIES',
              },
              {
                key: 6,
                color: '#B3CC85',
                title:
                  'industryOverview.macroeconomics.BALANCE_OF_TRADE_ALL_INDUSTRIES',
              },
            ]}
          />
        )}
      </div>
    </div>
  )
}
